<template>
    <div class="dataset-warning">
        <img src="@/assets/warning-icon.svg" alt="Warning" class="dataset-warning-item" />
        <div class="dataset-warning-message">
            <h2>
                {{ switchValue ? "Filtering suspended" : "You have filtered datasets" }}
            </h2>
            <p>
                {{ switchValue ? "Show with filters on entity details" : "Suspend filtering on entity details" }}
            </p>
        </div>
        <div class="dataset-warning-item">
            <label class="custom-switch">
                <input type="checkbox" role="switch" v-model="switchValue" v-on:change="toggleActiveFilters()"/>
                <span class="slider-round"></span>
            </label>
        </div>
    </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";

@Options({
    props: {
        initialSwitchValue: Boolean,
    },
    emits: ["datasetFilterUpdate"],
})
export default class DatasetFilterWarning extends Vue {
    initialSwitchValue!: boolean;
    switchValue = false;

    mounted() {
        this.switchValue = this.initialSwitchValue;
    }

    toggleActiveFilters() {
        this.$emit("datasetFilterUpdate", this.switchValue);
    }
}
</script>
<style>
.custom-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}

.custom-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.custom-switch .slider-round {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
}

.custom-switch .slider-round:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

.custom-switch input:checked+.slider-round {
  background-color: #083943;
}

.custom-switch input:focus+.slider-round {
  box-shadow: 0 0 1px #083943;
}

.custom-switch input:checked+.slider-round:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.dataset-warning {
    display: flex;
    align-items: center;
    margin: 0px 10px 4px 10px;
    background-color: #FDF9ED;
    border: #F1C21B 2px solid;
    border-radius: 4px;
}

.dataset-warning-message {
    flex-grow: 1;
}

.dataset-warning-message h2 {
    font-size: 16px;
    text-align: left;
    margin-bottom: 4px;
}

.dataset-warning-message p {
    font-size: 14px;
    text-align: left;
    margin-top: 0px;
}

.dataset-warning-item {
    padding: 12px;
}
</style>
